/** Default FAQ copy for UK Status Match campaigns. */
export const DEFAULT_STATUS_MATCH_FAQ_DEFINITIONS = [
  {
    question: 'How do I apply for the Société Status Match?',
    answer:
      "The Société Status Match is available by invitation only to select Société Bronze members in the UK. If you've received an invitation, simply complete the online application form before the campaign close date.\n\nNot yet a Société member? Join for free now.",
  },
  {
    question: 'What documentation will I need to provide?',
    answer:
      "You'll need to provide a colour copy (digital accepted) of your current membership card or a screenshot of your online account with the qualifying airline, hotel or OTA. The documentation must clearly show the program name, your eligible status tier, and your name.\n\nThe details must match those on your Société account. Société reserves the right to decline applications or cancel matched status if documentation is found to be inaccurate or does not meet our requirements.",
  },
  {
    question: 'Am I eligible if my status was gifted or transferred?',
    answer:
      "No. Only members who have earned their status through their own activity and met their program's published requirements are eligible. Status received through gifting, pooling, or complimentary grants does not qualify.",
  },
  {
    question: 'How long do I have to activate my Status Match?',
    answer:
      'Once enrolled, you have three months from your pre-approval date to book and complete a minimum stay of 3 nights on a Hotel, Tour, or Cruise.',
  },
  {
    question: 'When will my Société status be updated?',
    answer:
      'Your status will be updated within four weeks of returning from your stay. There is no need to contact us - this happens automatically.',
  },
  {
    question: 'How long will my matched status last?',
    answer:
      "You will hold your matched Société status until the end of your following membership year. To retain your status going forward, you'll need to continue meeting Société's standard retention requirements.",
  },
  {
    question: 'Can I apply for the Status Match more than once?',
    answer: 'No. The Société Status Match is available once per member, every three years.',
  },
  {
    question: 'What status can I be matched to?',
    answer:
      'Your matched status tier depends on your current qualifying status with an eligible program. See the Status Match table on this page for eligible programs and corresponding Société tiers.',
  },
  {
    question: 'What if I already hold Société Gold or Platinum?',
    answer:
      'The Status Match is designed to welcome members who hold Bronze status with Société. Members who already hold Gold or Platinum are not eligible to apply.',
  },
  {
    question: 'Where can I find more information about my current Société status?',
    answer: 'You can view your current Société tier and membership details in your Luxury Escapes account.',
  },
] as const;
